export default function StoreBadges({ center = true, testidPrefix = "store-badge" }) {
  return (
    <div className={`flex flex-wrap items-start gap-4 ${center ? "justify-center" : ""}`} data-testid={`${testidPrefix}-group`}>
      <a href="#" data-testid={`${testidPrefix}-appstore`} aria-label="Download on the App Store" className="store-badge">
        <img src="/brand/icon-apple.png" alt="" className="h-8 w-8" draggable="false" />
        <span className="text-left leading-tight">
          <span className="block text-[10px] text-white/70">Download on the</span>
          <span className="block text-[15px] font-semibold text-white -mt-0.5">App Store</span>
        </span>
      </a>
      <div className="relative" data-testid={`${testidPrefix}-googleplay-wrap`}>
        <a href="#" data-testid={`${testidPrefix}-googleplay`} aria-label="Get it on Google Play" className="store-badge">
          <img src="/brand/icon-google-play.png" alt="" className="h-8 w-8" draggable="false" />
          <span className="text-left leading-tight">
            <span className="block text-[10px] text-white/70">Download on the</span>
            <span className="block text-[15px] font-semibold text-white -mt-0.5">Google Play</span>
          </span>
        </a>
        <span className="gp-coming-soon" data-testid={`${testidPrefix}-googleplay-coming-soon`}>Coming soon</span>
      </div>
    </div>
  );
}
